import cardStyles from './CentaurCard.scss';
export var desktopSize = {
    width: parseInt(cardStyles['thumb-width'], 10),
    height: parseInt(cardStyles['thumb-height'], 10),
};
export var mobileSize = {
    width: parseInt(cardStyles['mobile-thumb-width'], 10),
    height: parseInt(cardStyles['mobile-thumb-height'], 10),
};
//# sourceMappingURL=sizes.js.map